<template>
  <!-- 会话邀请样式 -->
  <div class="chat-invite" v-if="page.vis">
    <!-- 弹窗样式 -->
    <div class="chat-invite__alert" :style="{ ...sizeStyle }" v-if="inviteStyle?.styleType === 1">
      <div class="flex flex-end">
        <i class="iconfont icon-close" @click="handleReject" />
      </div>
      <div class="chat-invite__alert-img flex flex-center">
        <img :src="inviteStyle.alertStyle.bgImg" />
      </div>
      <div class="chat-invite__alert-text line2">
        {{ inviteStyle.alertStyle?.text }}
      </div>
      <div class="flex flex-center">
        <div
          v-if="inviteStyle.alertStyle.submit.enabled === 1"
          class="chat-invite__alert-btn btn1 flex flex-center flex-item-center"
          :style="{ ...submitSize }"
          @click="handleEnter"
        >
          接受邀请
        </div>
        <div
          v-if="inviteStyle.alertStyle.cancel.enabled === 1"
          class="chat-invite__alert-btn btn2 flex flex-center flex-item-center"
          :style="{ ...cancelSize }"
          @click="handleReject"
        >
          关闭邀请
        </div>
      </div>
    </div>
    <!-- 浮层样式 -->
    <div class="chat-invite__float" v-if="inviteStyle.styleType === 0">
      <div class="chat-invite__float-header flex flex-item-center flex-between">
        <div class="flex flex-item-center">
          <img :src="inviteStyle.floatStyle.avatar" alt="" />
          客服
        </div>
        <i class="iconfont icon-close" @click="handleReject" />
      </div>
      <div class="chat-invite__float-content">
        <div class="chat-invite__float-text">{{ inviteStyle.floatStyle.text }}</div>
        <div class="chat-invite__float-btn" @click="handleEnter">进入咨询</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, reactive, defineExpose, defineEmits, onBeforeUnmount } from 'vue'
const props = defineProps({
  inviteStyle: {
    type: Object,
    default: () => {}
  }
})
const emit = defineEmits(['accept'])
const sizeStyle = computed(() => {
  return {
    width: `${props.inviteStyle.alertStyle.size.width}px`,
    height: `${props.inviteStyle.alertStyle.size.height}px`
  }
})
const cancelSize = computed(() => {
  return {
    width: `${props.inviteStyle.alertStyle.cancel?.size?.width}px`,
    height: `${props.inviteStyle.alertStyle.cancel?.size?.height}px`
  }
})
const submitSize = computed(() => {
  return {
    width: `${props.inviteStyle.alertStyle.submit?.size?.width}px`,
    height: `${props.inviteStyle.alertStyle.submit?.size?.height}px`
  }
})
const page = reactive({
  vis: false
})
const open = () => {
  page.vis = true
  let inviteData = localStorage.getItem('inviteData')||{}
  inviteData.inviteNum += 1
  localStorage.setItem('inviteData', JSON.stringify(inviteData))
}
// 拒绝邀请
const handleReject = () => {
  page.vis = false
  let inviteData = localStorage.getItem('inviteData')||{}
  inviteData.isRefuse = true
  localStorage.setItem('inviteData', JSON.stringify(inviteData))
  inviteData = null
  // 设置邀请定时器
  let custReject = props.inviteStyle.custReject || {}
  if (custReject?.enabled === 1 && custReject?.absent === 0) {
    let time = custReject.value * 1000
    setInviteTimer(time)
    time = null
  }
  custReject = null
}
// 设置邀请定时器
let timer
const setInviteTimer = (time) => {
  clearTimer()
  timer = setInterval(() => {
    let inviteData = localStorage.getItem('inviteData')||{}
    let custTrigger = props.inviteStyle.custTrigger || {}
    if (custTrigger.enabled && custTrigger.value >= inviteData.inviteNum) {
      clearTimer()
    } else {
      open()
    }
    inviteData = null
    custTrigger = null
  }, time)
}
// 清除定时器
const clearTimer = () => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}
// 接受邀请
const handleEnter = () => {
  emit('accept')
  close()
}
// 清除定时器
onBeforeUnmount(() => {
  clearTimer()
})

defineExpose({
  open
})
</script>

<style lang="less" scoped>
.chat-invite {
  width: 100%;
  height: 100vh;
  &__alert {
    background: #ffffff;
    box-shadow: 0px 1px 16px 0px rgba(64, 158, 255, 0.3);
    border-radius: 10px;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;
    .iconfont{
      font-size: 18px;
      color: #555555;
    }
  }
  &__alert-img {
    img {
      height: 200px;
      object-fit: cover;
    }
  }
  &__alert-text {
    font-size: 14px;
    color: #666666;
    margin: 24px 16px;
    width: calc(100% - 32px);
    max-height: 38px;
    word-break: break-all;
    text-align: center;
  }
  &__alert-btn {
    font-size: 14px;
    border-radius: 4px;
    & + & {
      margin-left: 64px;
    }
    &.btn1 {
      background: #409eff;
      color: #fafafb;
    }
    &.btn2 {
      border: 1px solid #888888;
      background: #ffffff;
      color: #888888;
    }
  }
  &__float {
    width: 400px;
    position: absolute;
    right: 20px;
    top: calc(50% - 200px);
  }
  &__float-header {
    padding: 14px 20px;
    background-color: #056ffa;
    border-radius: 10px 10px 0 0;
    font-size: 18px;
    color: #ffffff;
    img {
      width: 32px;
      height: 32px;
      margin-right: 12px;
      border-radius: 50%;
      object-fit: cover;
    }
    .iconfont {
      font-size: 24px;
      color: #ffffff;
    }
  }
  &__float-content {
    background-color: #eff2f5;
    border-radius: 0 0 10px 10px;
    padding: 12px 10px;
  }
  &__float-text {
    font-size: 16px;
    color: #555555;
  }
  &__float-btn {
    background: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    color: #056ffa;
    text-align: center;
    padding: 6px 0;
    width: 100%;
    margin-top: 40px;
  }
}
</style>
